export default "__VITE_ASSET__8a2516b6__"